<div class="model-cover terms" *ngIf="showModal">{{loadFocustelements()}}
  <div class="model-box modal-lg-width" (keydown)="handleKeydown($event)">
    <div class="modal-header">
      <h2 id='modalHeading' tabindex="-1">Terms & Conditions</h2>
      <div class="corner-button">
        <button class="close" aria-label="Close" (click)="btnAction('false')">x</button>
      </div>
    </div>
    <div class="modal-body">
        <h2 *ngIf="title ?.length > 0">{{title}} </h2>
      <div [innerHTML]="termsContentHtml"></div>
    </div>
    <div class="text-right modal-footer">
      <div class="btn-group">
        <a href="javascript:void(0)" class="btn btn-secondary pull-right" (click)="btnAction()" role="button" aria-label="OK.">OK</a>
        <a href="javascript:void(0)" class="btn btn-link" (click)="btnAction('no')">Cancel</a>
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
</div>